import { useSelector } from 'react-redux';
import { getModalsSelector } from '@store/modals/modals.selectors';
import { ModalComponent } from './modal.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Modals = function Modals() {
  var modals = useSelector(getModalsSelector);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: modals === null || modals === void 0 ? void 0 : modals.map(function (modal) {
      return /*#__PURE__*/_jsx(ModalComponent, {
        modalId: modal.modalId
      }, modal.modalId);
    })
  });
};

export { Modals };